import { useMutation, useQuery } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { displayNotify } from "../services/Notifications/NotificationServices";
import { qClient } from "../../index";

const handleError = (error: any) => {

  console.log(error)
  
  if (! ( error instanceof AxiosError ))
    return

  const data = error.response?.data

  if (data)  {
    displayNotify({status: 'info', title: 'Киберштаб', description: data.detail || data.error })
  }

}

const useEventRegistration = (eventID: string) => {

  const { data, isPending:regPending, error, mutate:regMutate } = useMutation({
    mutationFn: () => fetchRegister(eventID),
    onSuccess() {
        displayNotify({status: 'success', title: 'Киберштаб', description: 'Регистрация прошла успешно!', })
    },
    onError: handleError
  });

  const { isPending:unregPending, mutate:unregMutate } = useMutation({
    mutationFn: () => fetchUnregister(eventID),
    onSuccess() {
        displayNotify({status: 'success', title: 'Киберштаб', description: 'Регистрация отменена!', })
    },
    onError: handleError
  });



  return {  isPending: regPending || unregPending, error, regMutate, unregMutate };
};

const fetchRegister = async (eventID?: string) => {
  
  const response = await axios.post(`events/${eventID}/register/`);

  qClient.refetchQueries({
            queryKey: ["events"],
          });

  return response;
};

const fetchUnregister = async (eventID?: string) => {
  
  const response = await axios.delete(`events/${eventID}/register/`);

  qClient.refetchQueries({
    queryKey: ["events"],
  });


  return response;
};

export default useEventRegistration;

